import { NgModule } from '@angular/core';
import { DialogAnnouncementComponent } from './dialog-announcement/dialog-announcement.component';
import {AnnouncementLauncherComponent} from './launcher/announcement-launcher.component';
import {DialogExtInfoComponent} from './dialog-extinfo/dialog-extinfo.component';
import {SharedMainModule} from '@app/core/modules/shared-main.module';

@NgModule({
    imports: [
        SharedMainModule
    ],
    exports: [
        DialogAnnouncementComponent,
        DialogExtInfoComponent,
        AnnouncementLauncherComponent
    ],
    declarations: [
        DialogAnnouncementComponent,
        DialogExtInfoComponent,
        AnnouncementLauncherComponent
    ]
})
export class AnnouncementModule {

}
